import { __assign } from "tslib";
export var createOOIPlatformSiteBILogger = function (biToken, defaults, biLogger) {
    if (defaults === void 0) { defaults = {}; }
    var defaultsWithToken = __assign(__assign({}, defaults), { bi_token: biToken });
    var loggerFactory = typeof biLogger.factory === 'function' ? biLogger.factory() : biLogger;
    return loggerFactory.updateDefaults(defaultsWithToken).logger();
};
//# sourceMappingURL=configure-ooi-platform-site-bi-logger.js.map